import SvgRenderer from "@/components/svgRenderer/svgRenderer.vue";

export default {
	name: "InfoCardStat",
	props: {
		image: {
			type: String,
			default: () => "",
		},
		title: {
			type: String,
			default: () => "",
		},
		subTitle: {
			type: String,
			default: () => "",
		},
		tooltipContent: {
			type: Array,
			default: () => [],
		},
	},
	components: { SvgRenderer },
};
